export default __webpack_public_path__ + "sony-sound-forge.40c1b74c.png";